/**
 * Created by tareq on 30/12/19.
 */
export function tokenFormat(token) {
  "use strict";
  return token.replace(/\D/g, '').split('').reduce((a, b, i)  => [4,7,11,14].indexOf(i) == -1 ? (a + b) : (a + '-' + b), '');
}